import { connect } from 'react-redux';
var mapStateToProps = function (state) {
    var contentTags = [
        'Personal',
        'Feature',
        'Interviews',
        'Events',
        'News',
        'Official',
    ];
    var categoryTags = [
        'Animation',
        'Artisan Crafts',
        'Body Art',
        'Design',
        'Digital Art',
        'Traditional Art',
        'Photography',
        'Sculpture',
        'Mixed Media',
    ];
    return {
        contentTags: contentTags,
        categoryTags: categoryTags,
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=TagsPopup.container.js.map